var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box"},[_c('Header'),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-left"},[_c('Aside')],1),_c('div',{staticClass:"main-right"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }